const STORAGE_KEY = "bbcmaestro_gift_checkout";

export type GiftCheckoutDraft = Record<string, string>;

export function readGiftCheckoutDraft(): GiftCheckoutDraft {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};

    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed))
      return {};

    return Object.fromEntries(
      Object.entries(parsed).filter(
        (entry): entry is [string, string] => typeof entry[1] === "string"
      )
    );
  } catch {
    return {};
  }
}

export function saveGiftCheckoutDraft(attributes: GiftCheckoutDraft): void {
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ ...readGiftCheckoutDraft(), ...attributes })
    );
  } catch {
    // Private browsing can reject the write. The form still submits.
  }
}
